import { gql } from '@apollo/client';

export const GET_EXTERNAL_PREVIEW_LINK = gql`
  query GetExternalPreviewLink($experienceId: String!) {
    getExternalPreviewLink(experienceId: $experienceId) {
      externalPreview
    }
  }
`;
